/**
 * Created by Carsten Bühler
 * User: CBuehler on 27.01.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import ReactDOM from 'external/react-dom';
import PropTypes from 'external/prop-types';
import { Button, ListGroup } from 'external/react-bootstrap';
import translation from '../utils/translation';
import ScrollableDataComponent from '../components/ScrollableDataComponent';
import { FlagComponent } from '../components/FlagHOC';
import DataListHoc from './DataListHoc';
import { asArray } from '../utils/data-util';

class ScrollableDataList extends ScrollableDataComponent {

    componentWillUnmount() {
        this.listGroupDom = null;
    }

    getScrollContainerDomNode() {
        if (!this.listGroupDom) {
            this.listGroupDom = ReactDOM.findDOMNode(this.listGroup);
        }
        return this.listGroupDom;
    }

    renderComponent() {
        const {
            list,
            ListItem,
            onClick,
            propName,
            activeIds,
            disabledIds,
            listSize = 'list-medium',
            loadMoreRows,
            style = {},
            ...otherProps
        } = this.props;

        const l = asArray(list);
        const listItems = l && l.map ? l.map((item, index) => {
            const id = propName ? item[propName] : item.id ? item.id : index;
            return (
                <ListItem
                    {...otherProps}
                    key={id}
                    index={index}
                    item={item}
                    disabled={!!disabledIds[id]}
                    active={!!activeIds[id]}
                    onClick={onClick}
                />
            );
        }) : [];

        if (listItems.length === 0 && !(list && list._more)) {
            listItems.push(<div key={-1} className='error-message'>{translation.trans('no-entries')}</div>);
        }

        return (
            <section className='list-group-wrapper'>
                <ListGroup
                    className={'scrollable-list-group ' + listSize}
                    style={style}
                    ref={e => this.listGroup = e}
                    onScroll={this.onScroll.bind(this, list)}
                    as='div'
                >
                    <FlagComponent item={list}>
                        {listItems}
                    </FlagComponent>
                    {
                        !list._loading && list._more &&
                        <Button
                            className='load-more-spacer'
                            onClick={loadMoreRows}
                            variant='default'
                        >
                            <i className={'icon icon-fliwas-loader'} />
                        </Button>
                    }
                </ListGroup>
            </section>
        );
    }
}

ScrollableDataList.propTypes = {
    ListItem: PropTypes.func.isRequired,
    activeIds: PropTypes.object,
    disabledIds: PropTypes.object,
    list: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    propName: PropTypes.string,
    loadMoreRows: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    listSize: PropTypes.oneOf([ 'list-auto', 'list-small', 'list-medium', 'list-large' ]),
    style: PropTypes.object
};

export default DataListHoc(ScrollableDataList);



// WEBPACK FOOTER //
// ./js/components/ScrollableDataList.jsx